<template>
  <div class="wrapper">
    <div class="notification-pill" :class="permissionClass">
    <span class="dot"></span>
    <span>
      Notifications:
      <strong class="text-capitalize">{{ permissionLabel  }}</strong>
    </span>

    <button
      v-if="permission === 'default'"
      @click="requestPermission"
      class="btn enable"
    >
      Enable
    </button>

    <!-- Denied -->
    <button
      v-if="permission === 'denied'"

      class="btn settings"
    >
      Enable from Browser Settings
    </button>
  </div>


  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue"

const permission = ref("default")

const permissionLabel = computed(() => {
  switch (permission.value) {
    case "granted":
      return "Allowed"
    case "denied":
      return "Blocked"
    default:
      return "Give Permission"
  }
})
const permissionClass = computed(() => {
  return permission.value
})


onMounted(() => {
  permission.value = Notification.permission

  window.addEventListener("focus", () => {
    permission.value = Notification.permission
  })
})

const requestPermission = async () => {
  const result = await Notification.requestPermission()
  permission.value = result
}

</script>
<style scoped>
.wrapper{
    max-width: fit-content;
}
.notification-pill {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  font-size: 14px;
  gap: 12px;
}

.btn {
  border: none;
  padding: 6px 14px;
  border-radius: 999px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}
.btn::hover .settings{
  color: white !important;
}
.enable {
  background: #22c55e;
  color: white;
}

.settings {
  background: #dc2626;
  color: white;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.granted .dot {
  background: #22c55e;
}

.denied .dot {
  background: #ef4444;
}

.default .dot {
  background: #f59e0b;
}
</style>